/**
 * Handle state of limit orders
 */
import {
  ACTION_AFTER_UPDATE_LIMIT_ORDER,
  ACTION_CONSUME_LIMIT_ORDER,
  ACTION_DELETE_DONE_LIMIT_ORDER,
  ACTION_GET_LIMIT_ORDERS,
  ACTION_SET_LIMIT_ORDERS,
  ACTION_SET_LIMIT_ORDERS_TICKERS,
  ACTION_TRIGGER_LIMIT_ORDER,
  ACTION_SET_CREATING_LIMIT_ORDERS,
  ACTION_ADD_LIMIT_ORDER,
} from '../actions/limit_orders';
import {
  ILimitOrder,
  ITicker,
  IUpdateLimitOrderPayload,
  enums,
} from '@kattana-io/common';

export interface ILimitOrdersState {
  loading: boolean;
  orders: ILimitOrder[];
  activated: ILimitOrder[];
  tickers: Record<string, ITicker>;
}

const defaultState: ILimitOrdersState = {
  loading: false,
  orders: [],
  activated: [],
  tickers: {},
};

const cancelOrder = (
  state: ILimitOrdersState,
  payload: any
): ILimitOrdersState => {
  const { uuid } = payload.data;
  return {
    ...state,
    orders: state.orders.map((order: ILimitOrder) => {
      if (order.uuid == uuid) {
        return {
          ...order,
          status: enums.LimitOrderStatus.CANCELED,
        };
      }
      return order;
    }),
  };
};

const updateOrder = (
  state: ILimitOrdersState,
  payload: IUpdateLimitOrderPayload
) => {
  const { uuid } = payload;
  return {
    ...state,
    orders: state.orders.map((order: ILimitOrder) => {
      if (order.uuid == uuid) {
        return {
          ...order,
          price: payload.data.price,
          price_usd: payload.data.price_usd,
        };
      }
      return order;
    }),
  };
};

const limitOrdersReducer = (
  state: ILimitOrdersState = defaultState,
  action: any
): ILimitOrdersState => {
  switch (action.type) {
  case ACTION_ADD_LIMIT_ORDER:
    return {
      ...state,
      orders: [action.payload, ...state.orders],
      loading: false,
    };
  case ACTION_GET_LIMIT_ORDERS:
    return {
      ...state,
      loading: true,
      orders: [],
    };
  case ACTION_SET_LIMIT_ORDERS:
    return {
      ...state,
      loading: false,
      orders: action.payload.limit_orders,
      tickers: action.payload.tickers,
    };
  case ACTION_SET_LIMIT_ORDERS_TICKERS:
    return {
      ...state,
      tickers: action.payload,
    };
  case ACTION_TRIGGER_LIMIT_ORDER:
    return {
      ...state,
      activated: [action.payload, ...state.activated],
    };
  case ACTION_CONSUME_LIMIT_ORDER:
    return {
      ...state,
      orders: state.orders.map((item) => {
        if (item.id == action.payload.id) {
          item.status = enums.LimitOrderStatus.CONSUMED;
        }
        return item;
      }),
      activated: state.activated.filter(
        (item) => item.id != action.payload.id
      ),
    };
  case ACTION_DELETE_DONE_LIMIT_ORDER:
    return cancelOrder(state, action.payload);
  case ACTION_AFTER_UPDATE_LIMIT_ORDER:
    return updateOrder(state, action.payload);
  case ACTION_SET_CREATING_LIMIT_ORDERS:
    return {
      ...state,
      loading: action.payload,
    };
  default:
    return state;
  }
};

export default limitOrdersReducer;
